module.exports = __webpack_public_path__ + "static/media/michigan_logo.fb870661.png";